import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SpSwitchComponent } from '../../../../ui/sp-switch/src/sp-switch.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SpByteFormat } from '../../../../../common/pipes/byte-format.pipe';
@Component({
    selector: 'sp-video-preview',
    templateUrl: './sp-video-preview.component.html',
    styleUrls: ['./sp-video-preview.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, SpSwitchComponent, BsDropdownModule, TranslateModule, SpByteFormat],
})
export class SpVideoPreviewComponent {
    @Input() public file: any;
    @Input() public isFreeTariff: boolean = true;

    @Output() public removeFileEvent: EventEmitter<void> = new EventEmitter();
    @Output() public replaceFileEvent: EventEmitter<void> = new EventEmitter();
    @Output() public addVideos: EventEmitter<any> = new EventEmitter();
    @Output() public openImagePreviewFm: EventEmitter<any> = new EventEmitter();
    @Output() public removePreviewImage: EventEmitter<any> = new EventEmitter();

    showPoster: boolean = false;

    public addVideo(): void {
        this.addVideos.emit();
    }
    public togglePreview(showPoster): void {
        this.showPoster = showPoster;
        this.removePreview();
    }

    removePreview(): void {
        this.removePreviewImage.emit();
    }

    goToTariffs() {
        window.open(`${window.location.origin}/edu/tariffs`, '_blank');
    }
}
